// extracted by mini-css-extract-plugin
export default {"search":"index-module__search___VxMJa","icon":"index-module__icon___PvTk9"};